import * as e from "react";
import { forwardRef as o } from "react";
const d = o(
  function(t, r) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        fill: "none",
        ref: r,
        viewBox: "0 0 25 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...t
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M2.5 14.875H21.5V3.875H2.5V14.875ZM23 15.375L22.9951 15.4775C22.9472 15.948 22.573 16.3222 22.1025 16.3701L22 16.375H2C1.48232 16.375 1.05621 15.9817 1.00488 15.4775L1 15.375V3.375C1 2.82272 1.44772 2.375 2 2.375H22L22.1025 2.37988C22.6067 2.43121 23 2.85732 23 3.375V15.375Z",
          fill: "#000"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M8.10001 12.1874H16.1V7.56736H8.10001V12.1874ZM17.6 12.6874L17.5951 12.7899C17.5472 13.2603 17.1729 13.6346 16.7025 13.6825L16.6 13.6874H7.60001L7.49747 13.6825C7.02707 13.6346 6.65284 13.2603 6.60489 12.7899L6.60001 12.6874V7.06737C6.60001 6.51509 7.04772 6.06738 7.60001 6.06738H16.6C17.1523 6.06738 17.6 6.51509 17.6 7.06737V12.6874Z",
          fill: "#000"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M5 12.925L19 12.925",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 1.5
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12 20.9251L16 17.4251",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 0.75
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12 20.9251L7.99999 17.4251",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 0.75
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12 17.425L16 20.925",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 0.75
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12 17.425L7.99999 20.925",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 0.75
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12 14.425L16 17.925",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 0.75
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12 14.425L7.99999 17.925",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 0.75
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12 17.9251L17 13.925",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 0.75
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12 17.925L7 13.925",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 0.75
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12 20.925L12 12.925",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 0.75
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M8 20.925L8 17.6504C8 17.1707 7.91373 16.695 7.74532 16.2459L6.5 12.925",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 0.75
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M16 20.925L16 17.6504C16 17.1707 16.0863 16.695 16.2547 16.2459L17.5 12.925",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 0.75
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M10 20.925L10 17.4175C10 17.0904 9.95989 16.7646 9.88057 16.4473L9 12.925",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 0.75
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M14 20.925L14 17.4175C14 17.0904 14.0401 16.7646 14.1194 16.4473L15 12.925",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 0.75
        }
      )
    );
  }
);
export {
  d as BetBuilderBadgeBasketballRebounds
};
